import React, { useState, useEffect } from 'react';

const CombineSelection = ({ passage, questionId }) => {
	const [userFeedback, setUserFeedback] = useState(null);

	useEffect(() => {
		let userFeedback =
			!!passage &&
			passage.map((phrase, i) => {
				return (
					<span key={i}>
						<span dangerouslySetInnerHTML={{ __html: phrase }} />
						<span className={`to-be-selected position_${i}_${questionId}`}></span>
					</span>
				);
			});
		setUserFeedback(userFeedback);
	}, [passage, questionId]);

	return (
		<p className="converse-pasage-record quote text-center no-mouse-events text-2x ">
			{userFeedback}
		</p>
	);
};

export default CombineSelection;
